import api from "../../api";
import type {
  ContentCardData,
  ContentSectionConfig,
  ContentTopic,
  HomeApiItem,
  TopicContentsPage,
} from "../../../@types/portalAluno";
import { PORTAL_TOPIC_PAGE_SIZE } from "../../../config/portalAluno/constants";
import { mapApiItemsToCards } from "../../../utils/portalAluno/mappers/contentCardMapper";
import { mapApiTopics } from "../../../utils/portalAluno/mappers/topicMapper";

export const getSectionTopics = async (
  section: ContentSectionConfig
): Promise<ContentTopic[]> => {
  const response = await api.get("mobile/temas", {
    params: { type: section.topicType },
  });

  return mapApiTopics(response.data);
};

interface TopicContentsOptions {
  limit?: number;
  offset?: number;
}

export const getSectionTopicContents = async (
  section: ContentSectionConfig,
  topicId: number,
  { limit, offset }: TopicContentsOptions = {}
): Promise<ContentCardData[]> => {
  const response = await api.get<HomeApiItem[]>(section.topicContentsPath, {
    params: {
      idTema: topicId,
      ...(offset ? { offset } : {}),
      ...(limit ? { limite: limit } : {}),
    },
  });

  return mapApiItemsToCards(response.data, section.kind).map((card) => ({
    ...card,
    topicId,
  }));
};

export const getSectionTopicContentsPage = async (
  section: ContentSectionConfig,
  topicId: number,
  offset: number
): Promise<TopicContentsPage> => {
  const cards = await getSectionTopicContents(section, topicId, {
    limit: PORTAL_TOPIC_PAGE_SIZE,
    offset,
  });

  return { cards, itemCount: cards.length };
};
